import module from 'nominas/nomina/module.js'
import template from './template.html'

export default class NominasNominaBancosPagosCargamultipleEditarComponent {
  constructor () {
    this.empleados = []
    this.data = null
    this.empleado = null
  }

  $onChanges (changes) {
    if (changes.data) {
      this.data = angular.copy(this.data)
    }

    if (this.data && changes.empleados) {
      this.empleados = this.empleados.filter((item) => item.Total === this.data.Importe)
    }
  }

  asignar () {
    this.onAsignar({$data: this.empleado})
  }
}

module.component('nominasNominaBancosPagosCargamultipleEditar', {
  controller: NominasNominaBancosPagosCargamultipleEditarComponent,
  template,
  bindings: {
    data: '<',
    empleados: '<',
    onAsignar: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/bancos/pagos/cargamultiple/editar/component.js